import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateClientMutation } from '../../../generated/graphql';
import { FormField, FormTextArea } from '../../form';
import styles from './NewClientDialog.module.css';

type NewClientDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewClientDialog = (props: NewClientDialogProps) => {
    const { style, visible, onClose } = props;
    const [createClient, createClientResult] = useCreateClientMutation();
    const [name, setName] = useState('');
    const [longName, setLongName] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const nameError = submitted && !name.trim() ? 'Client Name is required.' : '';
    const longNameError = submitted && !longName.trim() ? 'Long name is required.' : '';
    const descriptionError = submitted && !description.trim() ? 'Description is required.' : '';

    const handleSubmit = () => {
        setSubmitted(true);
        if (!name.trim() || !longName.trim() || !description.trim()) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createClient({
            variables: {
                client: { name: name.trim(), longName: longName.trim(), description: description.trim() }
            }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            isLoading={createClientResult.loading}
            title="New Client"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewClientDialog}
            style={style}
            data-testid="NewClientDialog">
            <FormField label="Client Name" name="name" value={name} onChange={setName} required error={nameError} />
            <FormField label="Long name" name="longName" value={longName} onChange={setLongName} required error={longNameError} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} error={descriptionError} />
        </DialogBase>
    );
};

export default NewClientDialog;